import React from "react";
import Link from "next/link";
import InfiniteScroll from "react-infinite-scroll-component";
import cloudfront from "helpers/cloudfront";
import { saveRecipeAct } from "store/recipesReducer";
import { Icon } from "components/SvgIcons";
import {
  CardBody,
  CardImage,
  CardTime,
  CardTitle,
  Column,
  Card,
  PaymentBackground,
  CardActionIcons,
  CardAction,
} from "styles/MainCards.styled";
import { NoImage } from "styles/Preview.styled";
import CardIcon from "components/CardIcon";
import { Item } from "shared/Slider/styled";
import { timeConvert } from "../../../helpers/getFormatedTime";
import { Spinner } from "styles/App.styled";
import { RecipesListWrapper, Title, RecipesCardsWrap } from "./styled";
import { getImageName } from "../../../helpers";

const recipeStatus = (item) => {
  return item.purchased ? (
    <Icon icon="newpurchase" />
  ) : item.private ? (
    <Icon icon="private" />
  ) : item.paid ? (
    `$${item.price}`
  ) : (
    "Free"
  );
};

const RecipesList = ({ recipes, userId, isLoading, fetchNextRecipes, nextPage }) => {
  return (
    <RecipesListWrapper>
      {recipes.length > 0 ? <Title>Recipes</Title> : null}
      <InfiniteScroll
        style={{ overflow: "hidden" }}
        dataLength={recipes.length}
        next={fetchNextRecipes}
        hasMore={nextPage}
      >
        <RecipesCardsWrap>
          {recipes.map((item) => {
            return (
              <Column key={item.id}>
                <Card>
                  <CardImage>
                    <Link href="/recipe/[id]" as={`/recipe/${item.id}`} passHref>
                      <a>
                        {item.main_image ? (
                          <img
                            className="cloudfront"
                            src={cloudfront({ href: item.main_image, size: 500 })}
                            alt={getImageName(item.main_image)}
                          />
                        ) : (
                          <NoImage />
                        )}
                      </a>
                    </Link>
                    <PaymentBackground>{recipeStatus(item)}</PaymentBackground>
                    <CardAction>
                      <CardActionIcons>
                        <CardIcon
                          id={item.id}
                          type="recipes"
                          icon={item.saved ? "savedslide" : "saveslide"}
                          action={"save"}
                          setSaved={saveRecipeAct}
                        />
                      </CardActionIcons>
                      <CardTime>{timeConvert(item.total_time)}</CardTime>
                    </CardAction>
                  </CardImage>
                  <CardBody>
                    <CardTitle>{item.title}</CardTitle>
                    {userId != item.recipe_creator.id && (
                      <Item>
                        <Link href="/users/[id]" as={`/users/${item.recipe_creator.id}`} passHref>
                          <a>
                            {item.recipe_creator.show_business_name ? (
                              item.recipe_creator.business_name
                            ) : (
                              <>
                                {item.recipe_creator.first_name} {item.recipe_creator.last_name}
                              </>
                            )}
                          </a>
                        </Link>
                      </Item>
                    )}
                  </CardBody>
                </Card>
              </Column>
            );
          })}
        </RecipesCardsWrap>
      </InfiniteScroll>
      {isLoading && <Spinner />}
    </RecipesListWrapper>
  );
};

export default RecipesList;
